// 存放登录相关网络请求
import request from "@/utils/request.js"



// 获取购物车列表
export const addCart = (goodsId,goodsNum,goodsSkuId) => {
    return request.post("/cart/add",
        {
            goodsId,
            goodsNum,
            goodsSkuId
             
        }
    )
}


// 获取购物车列表

export const getCartList=()=>{
  return  request.get('/cart/list')
}